import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  amount: {
    textAlign: 'right',
    display: 'block',
    marginLeft: '4px !important',
  },
  
  columnHeight: {
    height: 30,
  },
  rightAlignContainer: {
    flex: 1,
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
  },
}));
